
export const AIRPORTS = [
    {
        airport: "CGK",
        city: "tangerang",
        country: "indonesia",
    },
    {
        airport: "KIX",
        city: "osaka",
        country: "jepang",
    },
    {
        airport: "ITM",
        city: "osaka",
        country: "jepang",
    },
    {
        airport: "KOBE",
        city: "osaka",
        country: "jepang",
    },
];

export const AIRLINES = [
    {
        name: "All Nippon Airways",
        path: "/airlines/ana_all_nippon.svg",
    },
    {
        name: "Japan Airlines",
        path: "/airlines/japan_airlines.svg",
    },
    {
        name: "China southren",
        path: "/airlines/china_southern.svg",
    },
    {
        name: "China eastren",
        path: "/airlines/china_eastren.svg",
    },
];